import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { message } from "antd";

import Certificates from './pages/Certificates/Certificates';
import CertificatePage from './pages/Certificates/CertificatePage';
import SettingsPage from './pages/Settings/SettingsPage';
import Objects from './pages/Equipment/Objects';
import ObjectPage from './pages/Equipment/ObjectPage';
import EquipmentPage from './pages/Equipment/EquipmentPage';
import AppLayout from './components/Layout';
import { BitrixProvider, useBitrix } from './context/BitrixContext';
import ExcelUpload from "./components/ExcelUpload";

const AppRoutes = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { user, loading } = useBitrix();

  // Показываем сообщение, только когда пользователь есть и контекст вставлен
  useEffect(() => {
    if (user) {
      messageApi.success(`Добро пожаловать, ${user.NAME || "Пользователь"}!`);
        console.log(user)

    }
  }, [user, messageApi]);

  // Не возвращаем простые <p> — оставляем layout, чтобы contextHolder был в дереве
  if (loading) return (
    <AppLayout>
      {contextHolder}
      <p>Загрузка...</p>
    </AppLayout>
  );

  if (!user) return (
    <AppLayout>
      {contextHolder}
      <p>Не удалось получить пользователя Bitrix24</p>
    </AppLayout>
  );

  return (
    <AppLayout>
      {contextHolder}
      <Routes>
        <Route path="/" element={<Navigate to="/certificates" />} />
        <Route path="/certificates" element={<Certificates />} />
        <Route path="/certificates/:id" element={<CertificatePage />} />
        <Route path="/objects" element={<Objects />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/objects/:objectId" element={<ObjectPage />} />
        <Route path="/objects/:objectId/equipment/:equipmentId/" element={<EquipmentPage />} />
      </Routes>
    </AppLayout>
  );
};

export default function App() {
  return (
    <BitrixProvider>
      <AppRoutes />
    </BitrixProvider>
  );
}
